/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

export default {
  appId: 'softwareDistribution',
  distributionList: ['Grp-AEM-PackageShare'],
  name: 'Software Distribution',
  path: '/downloads',
  access: [],
  sandbox: {
    history: {
      type: Sandbox.HISTORY_TYPES.SERVER,
      config: {
        absolutePaths: true,
        hashType: 'noslash'
      }
    },
    sources: {
      local: {
        discovery:
          'https://localhost/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      dev: {
        discovery:
          'https://publish-cm-p2606-e4989-ns-team-distributiondev.corp.ethos13-prod-va7.ethos.adobe.net/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      dev2: {
        discovery:
          'https://publish-cm-p2606-e7926-ns-team-distributiondev.corp.ethos13-prod-va7.ethos.adobe.net/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      dev3: {
        discovery:
        'https://publish-cm-p11553-e21241-ns-team-aem-sd-dev03.corp.ethos13-prod-va7.ethos.adobe.net/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      qa: {
        discovery:
          'https://publish-cm-p11553-e21242-ns-team-aem-sd-qa01.corp.ethos13-prod-va7.ethos.adobe.net/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      qacdn: {
        discovery:
            'https://publish-p11553-e21242.adobeaemcloud.com/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      prod: {
        discovery:
          'https://downloads.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      stagecdn: {
        discovery:
          'https://publish-p2606-e4990.adobeaemcloud.com/bin/softwaredistribution/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      },
      stage: {
        discovery:
          'https://publish-cm-p2606-e4990-ns-team-distributionstage.corp.ethos13-prod-va7.ethos.adobe.net/bin/softwaredistribution/login.html?configid=ims',
        payload: ['path'],
        withCredentials: true
      }
    }
  },
  serviceCode: '',
  hideTenant: true
};
